import styled from 'styled-components';
import { Div, FlexRow } from 'common/styles/oc-styled-components';
import { BREAKPOINTS } from 'common/styles/style-constants';

export const ReviewCardWrapper = styled(FlexRow)`
  border-bottom: ${props => props.borderBottom};
  padding-bottom: 60px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    flex-direction: column;
    margin-top: 30px;
    padding-bottom: 30px;
  }
`;

export const ReviewCardContainer = styled(Div)`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    width: 100%;
    margin: 0;
    display: flex;
    justify-content: space-between;
  }
`;

export const ReviewDataContainerDesktop = styled(Div)`
  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    display: none;
  }
`;

export const ReviewDataContainerMobile = styled(Div)`
  @media (min-width: ${BREAKPOINTS.mobileMax}px) {
    display: none;
  }
`;
